import { render, staticRenderFns } from "./MomoSelector.vue?vue&type=template&id=0cefba00&scoped=true&"
import script from "./MomoSelector.vue?vue&type=script&lang=js&"
export * from "./MomoSelector.vue?vue&type=script&lang=js&"
import style0 from "./MomoSelector.vue?vue&type=style&index=0&id=0cefba00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cefba00",
  null
  
)

export default component.exports